import Swal from "sweetalert2";

const CONFIRM_COLOR = "#198754";
const CANCEL_COLOR = "#6c757d";

export async function confirmEventStatusChange(t, { title, statusLabel, currentLabel }) {
  return Swal.fire({
    title: t("eventsStatusChangeConfirm"),
    text: t("eventsStatusChangeConfirmText", {
      title,
      from: currentLabel,
      to: statusLabel,
    }),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: t("eventsStatusChangeConfirmAction"),
    cancelButtonText: t("eventsCancel"),
    confirmButtonColor: CONFIRM_COLOR,
    cancelButtonColor: CANCEL_COLOR,
  });
}

export async function confirmReservationStatusChange(t, { guestName, statusLabel, currentLabel }) {
  return Swal.fire({
    title: t("eventReservationStatusChangeConfirm"),
    text: t("eventReservationStatusChangeConfirmText", {
      name: guestName,
      from: currentLabel,
      to: statusLabel,
    }),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: t("eventReservationStatusChangeConfirmAction"),
    cancelButtonText: t("cancel"),
    confirmButtonColor: CONFIRM_COLOR,
    cancelButtonColor: CANCEL_COLOR,
  });
}

export function showEventActionSuccess(t, { title, text }) {
  return Swal.fire({
    title,
    text,
    icon: "success",
    confirmButtonColor: CONFIRM_COLOR,
  });
}

export { CONFIRM_COLOR, CANCEL_COLOR };
